const SECTION_DEFINITIONS = [
  { canonical: 'summary', title: 'Professional Summary', aliases: ['professional summary', 'career summary', 'summary', 'profile', 'career profile', 'career objective', 'summary for career background', '个人简介', '个人概况', '专业概要', '职业概述', '求职目标', 'resume overview', '专业摘要', '职业摘要', '专业总结', '职业总结', '个人总结', '简历概述', '概述', '摘要'] },
  { canonical: 'experience', title: 'Professional Experience', aliases: ['professional experience', 'work experience', 'employment history', 'career history', 'additional work experience', 'experience', '专业经验', '专业经历', '工作经验', '工作经历', '职业经历', '工作履历', '职业履历', '从业经历', '任职经历'] },
  { canonical: 'education', title: 'Education', aliases: ['education', 'educational background', 'academic background', 'academic qualifications', 'academic qualifications & achievements', 'qualifications', '教育背景', '教育经历', '教育', '学历'] },
  { canonical: 'skills', title: 'Skills', aliases: ['areas of expertise', 'area of expertise', 'key competencies', 'core competencies', 'core skills', 'technical skills', 'computer literacy/ language/ skills', 'computer literacy', 'software skills', 'skills', 'languages & skills', '专业领域', '关键能力', '核心能力', '核心技能', '专业技能', '技术技能', '技能'] },
  { canonical: 'projects', title: 'Projects', aliases: ['projects', 'project experience', 'project engagement', '项目经验', '项目经历'] },
  { canonical: 'certifications', title: 'Certifications', aliases: ['training & certifications', 'training and certifications', 'certifications', 'certificates', 'awards', 'other certificate', '证书', '认证', '荣誉'] },
  { canonical: 'languages', title: 'Languages', aliases: ['languages', 'language', '语言能力', '语言'] },
  { canonical: 'contact', title: 'Personal Details', aliases: ['personal details', 'personal information', 'contact information', 'contact', '个人信息', '联系方式', '个人资料', '基本信息', '联系信息', '个人详情'] },
  { canonical: 'additional', title: 'Additional Information', aliases: ['additional information', 'aadditional information', 'other information', '其他信息'] },
];

const MONTH = '(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)';
const DATE_POINT = `(?:(?:\\d{1,2}\\s+)?${MONTH}\\.?\\s*\\d{4}|(?:0?[1-9]|1[0-2])[./-]\\d{4}|\\d{4}[./-](?:0?[1-9]|1[0-2])|(?:19|20)\\d{2}年(?:0?[1-9]|1[0-2])月(?:[0-3]?\\d日)?|(?:19|20)\\d{2}(?:年(?:0?[1-9]|1[0-2])月?)?|(?:19|20)\\d{2}年)`;
// Chinese writes an open-ended range without a separator ("2023年2月至今"), so
// "至今" has to be reachable directly and not only after a dash.
const DATE_RANGE = new RegExp(
  `(${DATE_POINT}\\s*(?:(?:[-–—]|to|至)\\s*(?:Present|Current|Now|至今|${DATE_POINT})|至今))`,
  'i',
);
const COMPANY_HINT = /\b(?:pte\.?\s*ltd|private\s+limited|ltd|limited|inc\.?|corporation|corp\.?|company|group|holdings?|logistics|systems?|singapore|agency|bank|pharma|chemicals?|technology|technologies|solutions?|services?|international|industries|university)\b|(?:有限公司|股份公司|集团|控股|株式会社|事务所|研究院|研究所|学院|大学|医院|银行|工厂|实业|贸易|科技|物流|传媒|资本|基金)/i;
const ROLE_HINT = /(?:\b(?:manager|executive|specialist|assistant|officer|coordinator|director|lead|engineer|consultant|intern|marketer|marketeer|merchandiser|administrator|operator|technician|representative|crew|cashier|accountant|developer|designer|architect|fellow|founder|co-founder|partner|planner|buyer|analyst|supervisor|sales|auditor|driver)\b|经理|主管|专员|助理|总监|主任|执行|顾问|工程师|分析师|采购|运营|物流|供应链|市场|销售|人事|财务|客服|店长|代表|会计|合伙人)/i;
const LOCATION_HINT = /^(?:singapore|malaysia|china|hong kong|taiwan|japan|korea|united states|usa|uk|united kingdom|australia|germany|france|india|indonesia|thailand|vietnam|philippines|uae|dubai|london|shanghai|beijing|shenzhen|hangzhou|guangzhou|tokyo|seoul|sydney|melbourne|jakarta|bangkok|kuala lumpur|penang|johor|selangor|singapore\s*pr|新加坡|中国|马来西亚|香港|台湾|日本|韩国|英国|美国|澳大利亚|德国|法国|印度|印尼|泰国|越南|菲律宾|迪拜|伦敦|上海|北京|深圳|广州|杭州|成都|武汉|南京|苏州|厦门|青岛|天津|重庆|西安|海外|亚太|全球)$/i;
const PROTECTED_LINE = /^(?:date\s+of\s+birth|dob|age|gender|sex|nationality|race|ethnicity|marital\s+status|religion|photo|portrait|birth\s*date|出生日期|年龄|性别|国籍|种族|婚姻|宗教)\s*[:：]/i;

// Office-to-text converters emit table rules as short dash runs on their own
// line, sometimes several per line ("--", "-- --"). They are layout artifacts,
// never resume content, so they are removed before any structure is derived.
const SEPARATOR_ONLY_LINE = /^\s*(?:[-_=–—]{2,}[ \t]*)+$/u;
const PAGE_MARKER_LINE = /^\s*---\s*(?:(?:OCR\s*)?(?:PAGE|页|頁|页面)\s*\d*|(?:PAGE|页|頁|页面)\s*\d+)\s*---\s*$/iu;

export function cleanResumeTextSeparators(value = '') {
  return String(value)
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .filter((line) => !SEPARATOR_ONLY_LINE.test(line) && !PAGE_MARKER_LINE.test(line))
    .map((line) => line
      .replace(/[ \t]+(?:-{3,}|_{3,}|={3,}|–{3,}|—{3,})(?=[ \t]|$)/gu, ' ')
      // Pandoc writes superscripts as "2^(nd)"; keep the text, drop the notation.
      .replace(/\^\(([\p{L}\p{N}]{1,4})\)/gu, '$1')
      .trimEnd())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

function cleanText(value = '') {
  return String(value).normalize('NFC').replace(/\u200b/g, '').replace(/\u00a0/g, ' ').replace(/[ \t]+/g, ' ').trim();
}

function headingKey(value = '') {
  return cleanText(value).toLocaleLowerCase().replace(/^[#*]+|[*:：]+$/g, '').replace(/[^\p{L}\p{N}]+/gu, '');
}

export function resumeCompanyLine(line = '') {
  const clean = cleanText(line);
  if (!clean || /^[•●▪◦·.*-]\s*/.test(clean)) return null;
  const match = clean.match(/^(.{2,80}?)[，,]\s*([^，,]{2,24})$/u);
  if (!match || /\d/.test(match[2]) || /[@|｜]/.test(clean)) return null;
  const country = cleanText(match[2]);
  if (!LOCATION_HINT.test(country) && !/^(?:city|state|province|county|branch|hq|headquarters|office)$/i.test(country)) return null;
  return { company: cleanText(match[1]), country };
}

function definitionForKey(key) {
  return SECTION_DEFINITIONS.find((definition) => definition.aliases.some((alias) => headingKey(alias) === key)) || null;
}

const HEADING_SPLIT = /\s*(?:&|＆|\/|\||\+|,|，|\band\b|\bor\b|与|和)\s*/i;
const HEADING_CONNECTOR = /^(?:&|＆|\/|\||\+|and|or|of|for|the|与|和)$/i;

// Section headings are written every which way, and a compound one -- "EDUCATION
// & PROFESSIONAL DEVELOPMENT", "Training and Certifications" -- names its section
// in one of its parts. Splitting is only safe on a line that is styled like a
// heading: this runs against every line of the resume, and a sentence that merely
// opens with a section word is body text, not a new section.
function headingLike(value = '') {
  const text = cleanText(value);
  if (!text || text.length > 60) return false;
  if (/^[•●▪◦·*-]/.test(text)) return false;
  if (/\d/.test(text)) return false;
  const words = text.split(/\s+/).filter(Boolean);
  if (!words.length || words.length > 7) return false;
  const significant = words.filter((word) => !HEADING_CONNECTOR.test(word));
  if (!significant.length) return false;
  // A heading is set apart by its case. CJK carries none, so a script without
  // lowercase is accepted on shape alone.
  const hasLower = significant.some((word) => /\p{Ll}/u.test(word));
  if (!hasLower) return true;
  return significant.every((word) => /^[\p{Lu}\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]/u.test(word));
}

function headingDefinition(value = '') {
  const exact = definitionForKey(headingKey(value));
  if (exact) return exact;
  if (!headingLike(value)) return null;
  const parts = cleanText(value).split(HEADING_SPLIT).map((part) => part.trim()).filter(Boolean);
  if (parts.length < 2) return null;
  for (const part of parts) {
    const found = definitionForKey(headingKey(part));
    if (found) return found;
  }
  return null;
}

function lineNoise(value = '') {
  const text = cleanText(value);
  return !text
    || /^[-_=~*–—]{3,}$/.test(text)
    || /^\[?(?:pic|picture|image)?\]$/i.test(text)
    || /^\d{1,3}$/.test(text)
    || /^curriculum\s+vitae$/i.test(text);
}

function dateRange(value = '') {
  return cleanText(value).match(DATE_RANGE)?.[1] || '';
}

function dateOnly(value = '') {
  const text = cleanText(value);
  const date = dateRange(text);
  return Boolean(date && cleanText(text.replace(date, '').replace(/^[()\s:：-]+|[()\s:：-]+$/g, '')) === '');
}

const ROLE_LABEL = /^(?:position|role|job\s+title|designation|职位|岗位)\s*[:：]\s*/i;
const NON_ROLE_LABEL = /^(?:period|duration|responsibilities|major responsibility|reason for leaving|company|任职期间|工作职责|离职原因)\s*[:：]/i;

function stripRoleLabel(value = '') {
  return cleanText(String(value).replace(ROLE_LABEL, ''));
}

function companyLike(value = '') {
  const text = cleanText(value);
  // A responsibility line can still carry a company keyword ("...service level,"),
  // so sentence punctuation and prose length disqualify it as an employer.
  if (text.length < 3 || !COMPANY_HINT.test(text)) return false;
  if (/[.!?。！？]$/.test(text) || /[,;:，；：、]$/.test(text)) return false;
  if (/[。！？；]/.test(text)) return false;
  const cjk = (text.match(/[\u3400-\u9fff]/g) || []).length;
  // Word counting is meaningless without spaces, so CJK names are bounded by length.
  return cjk >= 2 ? text.length <= 40 : text.length <= 150 && text.split(/\s+/).length <= 12;
}

// The employer line of a "Company / Position: / Period:" layout is identified by
// the labelled lines that follow it, so short brand names with no legal suffix
// ("Singtel") must qualify as well.
function employerLike(value = '') {
  const text = cleanText(value);
  return text.length >= 2 && text.length <= 90
    && !dateRange(text)
    && !/^[•●▪◦·.*-]\s*/.test(text)
    && !/[,;，；]$/.test(text)
    && !/^[^:：]{2,38}[:：]/.test(text)
    && text.split(/\s+/).length <= 12;
}

function roleLike(value = '') {
  const text = cleanText(value);
  return text.length >= 3 && text.length <= 180
    && !/^(?:position|period|responsibilities|major responsibility|reason for leaving)\s*[:：]?$/i.test(text)
    && !NON_ROLE_LABEL.test(text)
    && !/^[•●▪◦·.*-]\s*/.test(text)
    && !/[.!?。！？]$/.test(text);
}

function lineItem(text, lineNumber) {
  // Two-column Office tables flatten into continuation lines that start with the
  // separator of the label column (": Bachelor of Business Administration").
  return { text: cleanText(text).replace(/^[:：]\s*/, ''), lineNumber };
}

export function delimitedEntry(value = '') {
  const text = cleanText(value);
  if (!text || text.length > 200 || !text.includes('|')) return null;
  const parts = text.split('|').map((part) => cleanText(part)).filter(Boolean);
  if (parts.length < 2 || parts.length > 4) return null;
  const dateIndex = parts.findIndex((part) => dateOnly(part));
  if (dateIndex < 0) return null;
  const rest = parts.filter((_, position) => position !== dateIndex);
  if (!rest.length) return null;
  return { title: rest[0], meta: [...rest.slice(1), parts[dateIndex]] };
}

function detectEntryAt(lines, index) {
  const current = lines[index];
  const next = lines[index + 1];
  const after = lines[index + 2];
  const after3 = lines[index + 3];
  if (!current) return null;

  // The round-trip format this project emits for translation: one line of
  // pipe-separated fields where exactly one field is a date range. Recognising it
  // here keeps a translated resume structured without needing per-language
  // company or role keywords.
  const delimited = delimitedEntry(current.text);
  if (delimited) {
    return {
      consumed: 1,
      block: {
        type: 'entry', title: delimited.title, meta: delimited.meta,
        sourceLineStart: current.lineNumber, sourceLineEnd: current.lineNumber,
      },
    };
  }

  // "Company / Position: … / Period: …" is an explicit layout. It is resolved
  // before the positional heuristics so a labelled period can never be read as
  // the role title and the real role can never be read as a company summary.
  const labelledPosition = next?.text.match(ROLE_LABEL) && stripRoleLabel(next.text);
  if (labelledPosition && employerLike(current.text)) {
    const labelledPeriod = after?.text.match(/^(?:period|duration|任职期间)\s*[:：]\s*(.+)$/i);
    const periodText = labelledPeriod ? cleanText(labelledPeriod[1]) : (after && dateOnly(after.text) ? dateRange(after.text) : '');
    if (periodText && dateRange(periodText)) {
      return {
        consumed: 3,
        block: {
          type: 'entry', title: labelledPosition, meta: [current.text, periodText],
          sourceLineStart: current.lineNumber, sourceLineEnd: after.lineNumber,
        },
      };
    }
  }

  const compMatch = !dateRange(current.text) && (resumeCompanyLine(current.text) || (companyLike(current.text) ? { company: current.text, country: '' } : null));
  if (compMatch) {
    const compText = compMatch.country ? `${compMatch.company}, ${compMatch.country}` : current.text;
    let roleIndex = -1;
    let roleDate = '';
    let roleTitle = '';
    const summaryParts = [];
    for (let cursor = index + 1; cursor < lines.length && cursor <= index + 5; cursor += 1) {
      const candidate = lines[cursor];
      if (!candidate?.text || /^[•●▪◦·.*-]\s*/.test(candidate.text) || candidate.text.startsWith('▪')) break;
      const candDate = dateRange(candidate.text);
      if (candDate) {
        const roleText = stripRoleLabel(candidate.text.replace(candDate, '').replace(/^[|·•,:：\-—–\s]+|[|·•,:：\-—–\s]+$/g, ''));
        if (roleText && (roleLike(roleText) || ROLE_HINT.test(roleText))) {
          roleIndex = cursor;
          roleDate = candDate;
          roleTitle = roleText;
          break;
        }
      }
      if (dateOnly(candidate.text) && lines[cursor + 1] && (roleLike(lines[cursor + 1].text) || ROLE_HINT.test(lines[cursor + 1].text))) {
        roleIndex = cursor + 1;
        roleDate = candDate;
        roleTitle = stripRoleLabel(lines[cursor + 1].text);
        break;
      }
      if ((roleLike(candidate.text) || ROLE_HINT.test(candidate.text)) && lines[cursor + 1] && dateOnly(lines[cursor + 1].text)) {
        roleIndex = cursor + 1;
        roleDate = dateRange(lines[cursor + 1].text);
        roleTitle = stripRoleLabel(candidate.text);
        break;
      }
      summaryParts.push(candidate.text);
    }
    if (roleIndex > index && roleTitle && roleDate) {
      const companySummary = summaryParts.join(' ').replace(/\s+/g, ' ').trim();
      return {
        consumed: roleIndex - index + 1,
        block: {
          type: 'entry',
          title: roleTitle,
          meta: [compText, roleDate],
          ...(companySummary ? { companySummary } : {}),
          sourceLineStart: current.lineNumber,
          sourceLineEnd: lines[roleIndex].lineNumber,
        },
      };
    }
  }

  if (companyLike(current.text) && next && dateOnly(next.text) && after && roleLike(after.text)) {
    return {
      consumed: 3,
      block: {
        type: 'entry', title: stripRoleLabel(after.text), meta: [current.text, dateRange(next.text)],
        sourceLineStart: current.lineNumber, sourceLineEnd: after.lineNumber,
      },
    };
  }

  if (dateOnly(current.text) && next && roleLike(next.text)
      && (COMPANY_HINT.test(next.text) || /[,，]/.test(next.text) || /^[A-Z][A-Z0-9 &/(),.'-]{8,}$/.test(next.text))) {
    return {
      consumed: 2,
      block: {
        type: 'entry', title: next.text, meta: [dateRange(current.text)],
        sourceLineStart: current.lineNumber, sourceLineEnd: next.lineNumber,
      },
    };
  }

  const date = dateRange(current.text);
  if (date) {
    const rawBefore = current.text.slice(0, current.text.toLocaleLowerCase().indexOf(date.toLocaleLowerCase()));
    const before = cleanText(rawBefore.replace(/[(:,，\s-]+$/g, ''));
    const afterDate = cleanText(current.text.slice(current.text.toLocaleLowerCase().indexOf(date.toLocaleLowerCase()) + date.length).replace(/^[),，:\s-]+/g, ''));
    if (!before && afterDate && (COMPANY_HINT.test(afterDate) || /[,，]/.test(afterDate))) {
      return {
        consumed: 1,
        block: { type: 'entry', title: afterDate, meta: [date], sourceLineStart: current.lineNumber, sourceLineEnd: current.lineNumber },
      };
    }
    const parenthesizedCompanyPeriod = /\(\s*$/.test(rawBefore)
      && next && roleLike(next.text) && ROLE_HINT.test(next.text);
    if (before && (companyLike(before) || parenthesizedCompanyPeriod)) {
      const title = next && roleLike(next.text) ? next.text : before;
      return {
        consumed: title === before ? 1 : 2,
        block: {
          type: 'entry', title, meta: title === before ? [date] : [before, date],
          sourceLineStart: current.lineNumber, sourceLineEnd: title === before ? current.lineNumber : next.lineNumber,
        },
      };
    }
    if (before && roleLike(before) && ROLE_HINT.test(before)) {
      return {
        consumed: 1,
        block: { type: 'entry', title: before, meta: [date], sourceLineStart: current.lineNumber, sourceLineEnd: current.lineNumber },
      };
    }
  }
  return null;
}

const INSTITUTION_HINT = /\b(?:university|college|academy|school|polytechnic|institute|secondary|kaplan|ite)\b/i;

// "Level: Bachelor's Degree". Some resumes reach for a semicolon, so both count.
function labelledFact(value = '') {
  return /^[^:：;；]{2,40}\s*[:：;；]\s*\S/.test(cleanText(value));
}

function detectEducationAt(lines, index) {
  const current = lines[index];
  const next = lines[index + 1];
  if (!current) return null;
  const date = dateRange(current.text);
  if (date) {
    const dateIndex = current.text.toLocaleLowerCase().indexOf(date.toLocaleLowerCase());
    const remainder = cleanText(`${current.text.slice(0, dateIndex)} ${current.text.slice(dateIndex + date.length)}`.replace(/^[\s:：-]+|[\s:：-]+$/g, ''));
    if (remainder && INSTITUTION_HINT.test(remainder)) {
      return {
        consumed: 1,
        block: { type: 'entry', title: remainder, meta: [date], sourceLineStart: current.lineNumber, sourceLineEnd: current.lineNumber },
      };
    }
  }
  // A school can head its own line with the facts labelled beneath it, carrying
  // no date of its own. Neither branch above sees that, so the whole section
  // flattened into loose lines with no entry to group them under.
  const factFollows = lines.slice(index + 1, index + 4).some((item) => labelledFact(item.text));
  if (!labelledFact(current.text) && INSTITUTION_HINT.test(current.text) && !dateRange(current.text)
    && factFollows) {
    return {
      consumed: 1,
      block: {
        type: 'entry',
        title: cleanText(current.text),
        meta: [],
        sourceLineStart: current.lineNumber,
        sourceLineEnd: current.lineNumber,
      },
    };
  }
  if (dateOnly(current.text) && next && INSTITUTION_HINT.test(next.text)) {
    return {
      consumed: 2,
      block: { type: 'entry', title: next.text, meta: [dateRange(current.text)], sourceLineStart: current.lineNumber, sourceLineEnd: next.lineNumber },
    };
  }
  return null;
}

function blockFromLine(item) {
  const bullet = item.text.match(/^(?:[-*•●▪◦·.]|\d+[.)])\s+(.+)$/);
  if (bullet) return { type: 'bullet', label: '', text: cleanText(bullet[1]), sourceLineStart: item.lineNumber, sourceLineEnd: item.lineNumber };
  // Some resumes reach for a semicolon where they meant a colon. It is only read
  // as a label when every word of it is capitalised, which a sentence clause such
  // as "Managed inventory; delivered savings" is not.
  const semicolonLabel = item.text.match(/^([^:：;；]{2,38})[;；]\s*(.+)$/);
  const label = item.text.match(/^([^:：;；]{2,38})[:：]\s*(.+)$/)
    || (semicolonLabel && /^(?:[\p{Lu}][\p{L}\p{N}.]*)(?:\s+[\p{Lu}][\p{L}\p{N}.]*)*$/u.test(semicolonLabel[1].trim())
      ? semicolonLabel : null);
  if (label) return { type: 'bullet', label: cleanText(label[1]), text: cleanText(label[2]), sourceLineStart: item.lineNumber, sourceLineEnd: item.lineNumber };
  return {
    type: 'paragraph', text: item.text,
    strong: (/^[A-Z][A-Z0-9 &/()'-]{3,}$/.test(item.text) || /[:：]$/.test(item.text)) && item.text.length <= 100,
    sourceLineStart: item.lineNumber, sourceLineEnd: item.lineNumber,
  };
}

function splitBulletSentences(text = '') {
  if (!text || text.length < 120) return [text];
  const parts = text.split(/(?<=[.!?。！？;；])\s+(?=[A-Z\u3400-\u9fff])/).map(cleanText).filter(Boolean);
  if (parts.length > 1 && parts.every((part) => part.length >= 15)) {
    return parts;
  }
  return [text];
}

function appendBlock(blocks, block) {
  const previous = blocks.at(-1);
  const contiguous = previous && previous.sourceLineEnd + 1 === block.sourceLineStart;
  const continuation = contiguous && !block.strong && block.type === 'paragraph'
    && ((previous.type === 'bullet' && !/[.!?。！？]$/.test(previous.text))
      || (previous.type === 'paragraph' && !previous.strong && !/[.!?。！？:]$/.test(previous.text)));
  if (continuation) {
    const wrappedList = /[|｜]/.test(previous.text) || /[|｜]/.test(block.text);
    const separator = /-$/.test(previous.text) ? '' : (wrappedList ? ' | ' : ' ');
    previous.text = `${previous.text.replace(/-$/, '')}${separator}${block.text}`;
    previous.sourceLineEnd = block.sourceLineEnd;
    return;
  }
  blocks.push(block);
}

function parseBlocks(section) {
  const blocks = [];
  for (let index = 0; index < section.lines.length; index += 1) {
    if (section.canonical === 'experience') {
      const entry = detectEntryAt(section.lines, index);
      if (entry) {
        blocks.push(entry.block);
        index += entry.consumed - 1;
        continue;
      }
    }
    if (section.canonical === 'education') {
      const entry = detectEducationAt(section.lines, index);
      if (entry) {
        blocks.push(entry.block);
        index += entry.consumed - 1;
        continue;
      }
    }
    appendBlock(blocks, blockFromLine(section.lines[index]));
  }
  return blocks;
}

function splitPersonalIntro(section) {
  if (!['summary', 'additional'].includes(section.canonical)) return [section];
  const labelPattern = /^(?:name|working location|contact(?: no\.?)?|email(?: address)?|nationality|gender|age|race|ethnicity|marital status|work pass|last drawn|expected salary|availability)\s*[:：]/i;
  const labelIndexes = section.lines.map((item, index) => labelPattern.test(item.text) ? index : -1).filter((index) => index >= 0);
  if (labelIndexes.length < 2) return [section];
  let start = labelIndexes[0];
  if (start > 0 && roleLike(section.lines[start - 1].text)) start -= 1;
  const result = [];
  if (start > 0) result.push({ ...section, lines: section.lines.slice(0, start) });
  result.push({ canonical: 'contact', title: 'Personal Details', lines: section.lines.slice(start) });
  return result;
}

function implicitEducationStart(lines, index) {
  const current = lines[index]?.text || '';
  const next = lines[index + 1]?.text || '';
  return Boolean(dateRange(current)
    && /\b(?:university|college|academy|school|polytechnic|institute|secondary)\b/i.test(current)
    && /\b(?:bachelor|master|diploma|degree|foundation|certificate|gce|spm|nitec)\b/i.test(next));
}

function splitImplicitSections(sections) {
  const expanded = [];
  for (const section of sections) {
    let working = section;
    if (!['experience', 'education'].includes(section.canonical)) {
      const firstEntry = section.lines.findIndex((_, index) => {
        const entry = detectEntryAt(section.lines, index);
        return entry && (entry.consumed >= 2 || entry.block.meta.some((item) => COMPANY_HINT.test(item)));
      });
      if (firstEntry > 0) {
        expanded.push(...splitPersonalIntro({ ...section, lines: section.lines.slice(0, firstEntry) }));
        working = { canonical: 'experience', title: 'Professional Experience', lines: section.lines.slice(firstEntry) };
      }
    }

    if (working.canonical === 'experience') {
      const educationIndex = working.lines.findIndex((_, index) => implicitEducationStart(working.lines, index));
      const trailingIndex = working.lines.findIndex((item, index) => index > 0 && /^(?:languages?|software skills)\s*[:：]/i.test(item.text));
      const splitAt = [educationIndex, trailingIndex].filter((value) => value > 0).sort((a, b) => a - b)[0] ?? -1;
      if (splitAt > 0) {
        expanded.push({ ...working, lines: working.lines.slice(0, splitAt) });
        const tail = working.lines.slice(splitAt);
        if (educationIndex === splitAt) {
          const languageIndex = tail.findIndex((item) => /^(?:languages?|software skills)\s*[:：]/i.test(item.text));
          expanded.push({ canonical: 'education', title: 'Education', lines: languageIndex > 0 ? tail.slice(0, languageIndex) : tail });
          if (languageIndex > 0) expanded.push({ canonical: 'skills', title: 'Languages & Skills', lines: tail.slice(languageIndex) });
        } else {
          expanded.push({ canonical: 'skills', title: 'Languages & Skills', lines: tail });
        }
        continue;
      }
    }
    expanded.push(...splitPersonalIntro(working));
  }
  return expanded.filter((section) => section.lines.length);
}

function parseTextStructure(sourceText) {
  const sections = [];
  let current = { canonical: 'summary', title: 'Resume Overview', lines: [] };
  const flush = () => {
    if (current.lines.length) sections.push(current);
  };
  String(sourceText).replace(/\r\n?/g, '\n').split('\n').forEach((rawLine, index) => {
    const text = cleanText(rawLine);
    if (lineNoise(text)) return;
    const definition = headingDefinition(text);
    if (definition) {
      flush();
      current = { canonical: definition.canonical, title: definition.title, lines: [] };
      return;
    }
    const markdownHeading = text.match(/^#{1,4}\s+(.{1,60})$/);
    if (markdownHeading) {
      flush();
      const label = cleanText(markdownHeading[1]);
      current = { canonical: 'additional', title: label || 'Additional Information', lines: [] };
      return;
    }
    const inlineHeading = text.match(/^([^:：]{2,50})[:：]\s*(.+)$/);
    const inlineDefinition = inlineHeading && headingDefinition(inlineHeading[1]);
    if (inlineDefinition && current.canonical !== 'experience') {
      flush();
      current = { canonical: inlineDefinition.canonical, title: inlineDefinition.title, lines: [lineItem(text, index + 1)] };
      return;
    }
    if (current.canonical !== 'contact' && /^(?:name|working location)\s*[:：]/i.test(text)) {
      flush();
      current = { canonical: 'contact', title: 'Personal Details', lines: [] };
    }
    current.lines.push(lineItem(text, index + 1));
  });
  flush();
  return splitImplicitSections(sections).map((section) => ({
    canonical: section.canonical,
    title: section.title,
    pageNumbers: [],
    blocks: parseBlocks(section),
  }));
}

function blockFingerprint(block) {
  return [block.type, block.title, ...(block.meta || []), block.label, block.text]
    .filter(Boolean).join('|').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
}

function trimCertificationPortfolioTail(blocks = []) {
  const markerIndex = blocks.findIndex((block) => {
    const value = block.type === 'entry' ? block.title : block.text;
    return headingKey(value) === 'portfolio';
  });
  return markerIndex >= 0 ? blocks.slice(0, markerIndex) : blocks;
}

function looksLikeCertificationTitle(value = '') {
  const text = cleanText(value);
  if (!text || text.length > 100 || /^https?:\/\//i.test(text)) return false;
  if (!/(?:[-:：|])$/.test(text)) return false;
  const words = text.split(/\s+/).filter((word) => /[\p{L}\p{N}]/u.test(word));
  if (words.length < 2) return false;
  const titleLikeWords = words.filter((word) => /^[\p{Lu}\p{N}]/u.test(word)).length;
  return titleLikeWords / words.length >= 0.5;
}

function normalizeCertificationBlocks(blocks = []) {
  const normalized = [];
  for (const block of blocks) {
    if (block.type !== 'entry') {
      normalized.push(block);
      continue;
    }
    const lines = [block.title, ...(block.meta || [])].map(cleanText).filter(Boolean);
    if (!lines.length) continue;
    const groups = [];
    let current = [];
    for (const line of lines) {
      if (current.length && looksLikeCertificationTitle(line)) {
        groups.push(current);
        current = [];
      }
      current.push(line);
    }
    if (current.length) groups.push(current);
    groups.forEach((group) => normalized.push({
      ...block,
      title: group[0],
      meta: group.slice(1),
    }));
  }
  return normalized;
}

// The extractor emits one meta value per line of the original column, so a
// course name the page wrapped arrives as two, and the dates it pushed out
// arrive as a paragraph of their own. Everything between the qualification and
// the dates is one name broken by the layout, not several separate facts.
function foldEducationMeta(meta = []) {
  const dated = meta.filter((item) => dateRange(item) || dateOnly(item));
  const rest = meta.filter((item) => !dated.includes(item));
  if (rest.length <= 1) return [...rest, ...dated];
  return [rest[0], rest.slice(1).join(' '), ...dated];
}

function normalizeEducationBlocks(blocks) {
  const merged = [];
  for (const block of blocks) {
    const previous = merged.at(-1);
    const datesOnly = ['paragraph', 'bullet'].includes(block.type)
      && !block.label && (dateRange(block.text) === cleanText(block.text) || dateOnly(block.text));
    if (previous?.type === 'entry' && datesOnly) {
      previous.meta = [...(previous.meta || []), cleanText(block.text)];
      continue;
    }
    merged.push(block.type === 'entry' ? { ...block, meta: [...(block.meta || [])] } : block);
  }
  return merged.map((block) => (block.type === 'entry'
    ? { ...block, meta: foldEducationMeta(block.meta) }
    : block));
}

function normalizeSemanticSections(structure) {
  return (structure.sections || []).map((section) => {
    const seen = new Set();
    const blocks = [];
    for (const rawBlock of section.blocks || []) {
      if (section.canonical !== 'experience') {
        const fingerprint = blockFingerprint(rawBlock);
        if (!fingerprint || seen.has(fingerprint)) continue;
        seen.add(fingerprint);
        blocks.push(rawBlock);
        continue;
      }
      if (rawBlock.type === 'entry') {
        let title = rawBlock.title;
        const meta = [...(rawBlock.meta || [])];
        const splitMatch = title.match(/^(.+?)\s*(?:[—–|·]|—|–)\s*(.+)$/);
        if (splitMatch) {
          const first = cleanText(splitMatch[1]);
          const second = cleanText(splitMatch[2]);
          if ((roleLike(first) || ROLE_HINT.test(first)) && (companyLike(second) || COMPANY_HINT.test(second))) {
            title = first;
            if (!meta.includes(second)) meta.unshift(second);
          } else if ((companyLike(first) || COMPANY_HINT.test(first)) && (roleLike(second) || ROLE_HINT.test(second))) {
            title = second;
            if (!meta.includes(first)) meta.unshift(first);
          }
        }
        blocks.push({ ...rawBlock, title, meta });
        continue;
      }
      if (rawBlock.type === 'bullet' || rawBlock.type === 'paragraph') {
        const subSentences = splitBulletSentences(rawBlock.text);
        if (subSentences.length > 1) {
          for (const sub of subSentences) {
            blocks.push({ ...rawBlock, type: 'bullet', text: sub });
          }
        } else {
          blocks.push(rawBlock);
        }
        continue;
      }
      blocks.push(rawBlock);
    }
    const normalizedBlocks = section.canonical === 'certifications'
      ? normalizeCertificationBlocks(trimCertificationPortfolioTail(blocks))
      : blocks;
    if (section.canonical === 'education') {
      return { ...section, blocks: normalizeEducationBlocks(normalizedBlocks) };
    }
    return { ...section, blocks: normalizedBlocks };
  }).filter((section) => section.blocks.length);
}

const SECTION_ORDER = {
  contact: 10,
  summary: 20,
  experience: 30,
  education: 40,
  skills: 50,
  certifications: 60,
  languages: 70,
  projects: 80,
  additional: 90,
};

function mergeCanonicalSections(sections) {
  const merged = new Map();
  for (const section of sections) {
    const existing = merged.get(section.canonical);
    if (existing) {
      existing.blocks.push(...section.blocks);
      existing.pageNumbers = [...new Set([...(existing.pageNumbers || []), ...(section.pageNumbers || [])])];
    } else {
      merged.set(section.canonical, { ...section, blocks: [...section.blocks] });
    }
  }
  return [...merged.values()].sort((left, right) =>
    (SECTION_ORDER[left.canonical] || 100) - (SECTION_ORDER[right.canonical] || 100));
}

function documentStructureText(structure = {}) {
  return (structure.sections || []).flatMap((section) => [section.title, ...(section.blocks || []).flatMap((block) => [
    block.title, ...(block.meta || []), block.label, block.text,
  ])]).filter(Boolean).join('\n');
}

export function resumeSourceText(extraction = {}) {
  const visionText = String(extraction.visionText || '') || (extraction.visionOcr || [])
    .filter((page) => page?.text?.trim())
    .sort((a, b) => Number(a.pageNumber || 0) - Number(b.pageNumber || 0))
    .map((page) => page.text.trim()).join('\n\n');
  return cleanResumeTextSeparators(String(extraction.text || '').trim() || visionText.trim() || String(extraction.ocrText || '').trim());
}

export function hasCompleteResumeDocumentStructure(extraction = {}) {
  const structure = extraction.documentStructure;
  if (!/^pdf-semantic-v[123]$/.test(structure?.version || '') || !structure.sections?.length) return false;
  const experienceSections = structure.sections.filter((section) => section.canonical === 'experience');
  const experienceEntries = experienceSections.flatMap((section) => section.blocks || []).filter((block) => block.type === 'entry');
  const malformedEntries = experienceEntries.filter((entry) => !entry.title || /^[-–—]+$/.test(entry.title.trim()) || dateRange(entry.title));
  const misplacedExperienceHeading = structure.sections.some((section) => section.canonical !== 'experience'
    && (section.blocks || []).some((block) => headingKey(block.text || block.title) === headingKey('additional work experience')));
  if (malformedEntries.length || misplacedExperienceHeading) return false;
  const sourceText = resumeSourceText(extraction);
  if (!sourceText) return true;
  const sourceCharacters = sourceText.replace(/\s/g, '').length;
  const structuredCharacters = documentStructureText(structure).replace(/\s/g, '').length;
  return structuredCharacters >= sourceCharacters * 0.45;
}

export function buildResumeStructureIndex(extraction = {}) {
  const sourceText = resumeSourceText(extraction);
  const semantic = hasCompleteResumeDocumentStructure(extraction);
  const sections = mergeCanonicalSections(semantic
    ? normalizeSemanticSections(extraction.documentStructure)
    : parseTextStructure(sourceText));
  const entries = sections.reduce((sum, section) => sum + section.blocks.filter((block) => block.type === 'entry').length, 0);
  const structuredCharacters = documentStructureText({ sections }).length;
  return {
    version: 'resume-index-v2',
    mode: semantic ? 'pdf-semantic' : 'source-lines',
    sourceCharacters: sourceText.length,
    structuredCharacters,
    reliable: Boolean(sections.length && (semantic || entries > 0 || sections.length > 2)),
    sections,
  };
}

export function isProtectedResumeLine(value = '') {
  return PROTECTED_LINE.test(cleanText(value));
}

function visibleBlockText(block) {
  return [block.label ? `${block.label}:` : '', block.text].filter(Boolean).join(' ');
}

export function resumeStructureOutline(index, assetName = 'Resume') {
  const lines = [`## ${assetName}`];
  for (const section of index.sections || []) {
    if (['contact', 'additional'].includes(section.canonical)) continue;
    const entries = section.blocks.filter((block) => block.type === 'entry');
    const compact = section.blocks.filter((block) => block.type !== 'entry'
      && ['education', 'skills', 'certifications', 'languages'].includes(section.canonical));
    if (!entries.length && !compact.length) continue;
    lines.push(`### ${section.title}`);
    entries.forEach((entry) => lines.push(`- ${entry.title}${entry.meta?.length ? ` | ${entry.meta.join(' | ')}` : ''}`));
    compact.slice(0, 30).forEach((block) => {
      const text = visibleBlockText(block);
      if (text && !isProtectedResumeLine(text)) lines.push(`- ${text.slice(0, 260)}`);
    });
  }
  return lines.join('\n');
}

export function resumeStructureEvidenceBlocks(index, assetName = 'Resume') {
  const chunks = [];
  for (const section of index.sections || []) {
    if (section.canonical === 'contact') continue;
    let current = null;
    const flush = () => {
      if (!current?.lines.length) return;
      chunks.push({
        label: current.label,
        section: section.canonical,
        text: current.lines.join('\n'),
      });
      current = null;
    };
    for (const block of section.blocks || []) {
      if (block.type === 'entry') {
        flush();
        current = {
          label: `${section.title} · ${block.title}`,
          lines: [`${block.title}${block.meta?.length ? ` | ${block.meta.join(' | ')}` : ''}`],
        };
        continue;
      }
      const text = visibleBlockText(block);
      if (!text || isProtectedResumeLine(text)) continue;
      if (!current) current = { label: section.title, lines: [] };
      current.lines.push(block.type === 'bullet' ? `- ${text}` : text);
      if (current.lines.join('\n').length >= 2200) flush();
    }
    flush();
  }
  return chunks.map((chunk, indexNumber) => ({ ...chunk, assetName, order: indexNumber }));
}

function translationEntryLines(section, block) {
  const title = String(block.title || '').trim();
  const meta = (block.meta || []).map((item) => String(item || '').trim()).filter(Boolean);
  if (!title) return [];
  if (section.canonical !== 'experience') {
    return [`${title}${meta.length ? ` | ${meta.join(' | ')}` : ''}`];
  }
  const dateIndex = meta.findIndex((item) => dateRange(item));
  if (dateIndex < 0) return [`${title}${meta.length ? ` | ${meta.join(' | ')}` : ''}`];
  const date = meta[dateIndex];
  const context = meta.filter((_, index) => index !== dateIndex).join(' | ');
  const lines = [[title, context, date].filter(Boolean).join(' | ')];
  if (block.companySummary) lines.push(block.companySummary);
  return lines;
}

// Give translation models the same stable hierarchy that the UI uses for the
// structured original, while keeping the output contract as readable text.
export function resumeStructureTranslationSource(index, assetName = 'Resume') {
  if (!index?.sections?.length) return '';
  const lines = [`# ${assetName}`];
  for (const section of index.sections) {
    lines.push('', `## ${section.title}`);
    for (const block of section.blocks || []) {
      if (block.type === 'entry') {
        lines.push(...translationEntryLines(section, block));
        continue;
      }
      const text = visibleBlockText(block);
      if (!text) continue;
      lines.push(block.type === 'bullet' ? `- ${text}` : text);
    }
  }
  return lines.join('\n').trim();
}

// Field-level translation. Serialising the structure to text and parsing it back
// made every round trip depend on the model reproducing an exact vocabulary, which
// is what produced the company, heading and date-range regressions. Here the
// structure never leaves our hands: the model only ever sees a flat map of strings.
const UNTRANSLATED_CANONICALS = new Set(['contact']);

function translatableBlockFields(section, block) {
  const fields = [];
  if (block.type === 'entry') {
    // Company names, dates and school names stay in their original language, so
    // only the role title and the company description are offered.
    if (section.canonical === 'experience' && block.title) fields.push('title');
    if (block.companySummary) fields.push('companySummary');
    return fields;
  }
  // In personal details only the field labels are language, the values are data.
  if (UNTRANSLATED_CANONICALS.has(section.canonical)) {
    if (block.label) fields.push('label');
    return fields;
  }
  if (block.label) fields.push('label');
  if (block.text) fields.push('text');
  return fields;
}

export function collectResumeTranslationItems(index) {
  const items = [];
  (index?.sections || []).forEach((section, sectionIndex) => {
    (section.blocks || []).forEach((block, blockIndex) => {
      for (const field of translatableBlockFields(section, block)) {
        const text = String(block[field] || '').trim();
        if (text) items.push({ path: `${sectionIndex}.${blockIndex}.${field}`, text });
      }
    });
  });
  return items;
}

export function applyResumeTranslation(index, translations = {}) {
  return {
    ...index,
    sections: (index?.sections || []).map((section, sectionIndex) => ({
      ...section,
      blocks: (section.blocks || []).map((block, blockIndex) => {
        const translated = { ...block };
        for (const field of translatableBlockFields(section, block)) {
          const value = translations[`${sectionIndex}.${blockIndex}.${field}`];
          if (typeof value === 'string' && value.trim()) translated[field] = value.trim();
        }
        return translated;
      }),
    })),
  };
}

// A readable flattening for the raw-text reference view and for evidence hashing.
export function resumeStructureToText(index) {
  return resumeStructureTranslationSource(index, '').replace(/^#\s*\n+/, '').trim();
}
